import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

import CustomModal from 'af-components/CustomModal';

interface Props {
	closeModal: () => void;
	showModal: boolean;
}

const WorkOrderLockedModal: React.FC<Props> = (props) => {

	const { showModal, closeModal } = props;

	return (
		<CustomModal
			closeModal={closeModal}
			modalStyle="warning"
			showModal={showModal}
			size="sm"
		>
			<CustomModal.Header
				closeModal={closeModal}
				title="Work Order Locked"
			/>
			<CustomModal.Body>
				<p>This work order has been locked and no further changes can be made.</p>
			</CustomModal.Body>
			<CustomModal.Footer>
				<Button
					label="Close"
					onClick={closeModal}
					style="primary"
				/>
			</CustomModal.Footer>
		</CustomModal>
	);
};

export default React.memo(WorkOrderLockedModal);
